import React from 'react';
import Helmet from 'react-helmet';
import { createOpenGraphMetadata } from '../../helpers/metadata-helper';
import { WatchAnywhere } from '../../components/watch-anywhere';
import './index.less';
import baseUrls from '../../data/baseUrls';

export default class WatchAnywherePage extends React.Component {
	componentDidMount() {
		const el = document.getElementById('app');
		if (el) {
			el.classList.add('WatchAnywhere');
		}
	}

	componentWillUnmount() {
		const el = document.getElementById('app');
		if (el) {
			el.classList.remove('WatchAnywhere');
		}
	}

	render() {
		const imageUrl = `${baseUrls.faithlifeTv}/public/images/watch-anywhere-og.png`;
		const meta = createOpenGraphMetadata(imageUrl);

		return (
			<div>
				<Helmet title="Watch Anywhere" meta={meta} />
				<WatchAnywhere />
			</div>
		);
	}
}
